
import { mapGetters } from 'vuex'
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import OnlineAttendantsList from "@/components/OnlineAttendantsList.vue";

@Component({
  components: {
    OnlineAttendantsList
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature']),

    isBvFgts () {
      return ['bv-fgts-app'].includes(this.$auth.user().platform_name)
    }
  }
})
export default class BaseSideBar extends Vue {
  private mainProps = { width: 175, height: 175 };

  @Prop(Boolean) private toogleSidebar: boolean = false;

  private isPlatformRole = this.$auth.user().profile === 'platform';
  private isDemoPlatform = this.$auth.user().id_platform === 705;
}
